export const TextWrapper = ({
  text,
  isHighlighted,
  style,
  is_activated,
}: {
  text: string;
  isHighlighted?: boolean;
  style?: React.CSSProperties;
  is_activated?: boolean;
}) => {
  return (
    <span
      style={{
        fontSize: "14px",
        fontWeight: isHighlighted ? 550 : 400,
        color: is_activated ? "#17683A" : "#1F2932",
        userSelect: "none",
        ...style,
      }}
    >
      {text}
    </span>
  );
};
